import type { ResultData, ResultItem } from '@/domain';

type RecommendationImage = {
    isAbsolute: boolean;
    type: string;
    url: string;
};

type RecommendationItem = {
    image: RecommendationImage;
};

type RecommendationResponse = {
    items: RecommendationItem[];
};

export const apiListAdImageWrapper = (res: ResultData): ResultData => {
    if (res?.resultItems && Array.isArray(res.resultItems)) {
        fixAdImages(res.resultItems);
    }
    return res;
};

const fixAdImages = (images: ResultItem[]) => {
    images
        .filter((item) => item.imageurl !== undefined)
        .forEach((item) => {
            item.imageurl = prependImageUrl(item.imageurl);
        });
};

export const apiRecommendedAdImageWrapper = (res: RecommendationResponse | string): RecommendationResponse | string => {
    if (typeof res !== 'string' && res?.items && Array.isArray(res.items)) {
        fixRecommendationImages(res.items);
    } else {
        try {
            const obj = JSON.parse(res as string) as RecommendationResponse;

            fixRecommendationImages(obj.items);

            res = JSON.stringify(obj);
        } catch (error) {
            console.log(`apiRecommendedAdImageWrapper failed with ${error}`);
        }
    }

    return res;
};

const fixRecommendationImages = (images: RecommendationItem[]) => {
    images
        .filter((item) => item.image !== undefined && item.image.isAbsolute === false)
        .forEach((item) => {
            item.image.url = prependImageUrl(item.image.url);
        });
};

export const prependImageUrl = (imageUrl: string): string => {
    if (imageUrl.includes('http')) {
        return imageUrl;
    } else {
        return `https://images.finncdn.no/dynamic/default/${imageUrl}`;
    }
};
